export enum CreditoRealSentInfoStatus {
    SENT_SUCCESS = 'SENT_SUCCESS',
    SENT_ERROR = 'SENT_ERROR',
    NOT_SENT = 'NOT_SENT'
}
